import React, { Component } from 'react';
import { Button, Col, Descriptions, Divider, Drawer, Image, Row, Space, Spin, Tag, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import { checkPermission } from '@/utils/permission';
import { _newLine, ConvertRewardType, isValidDate } from '@/utils/helpers';
import RewardSpinForm from './RewardSpinForm';

const { Text } = Typography;

class RewardSpinDetail extends Component {
    state = { isOpenForm: false };

    renderVideos = videos => {
        if (!videos || typeof DOMParser === 'undefined') return null;
        const documentNode = new DOMParser().parseFromString(videos, 'text/html');
        const sources = Array.from(documentNode.querySelectorAll('iframe'))
            .map(frame => frame.getAttribute('src'))
            .filter(source => {
                try {
                    const url = new URL(source);
                    const host = url.hostname.toLowerCase();
                    return url.protocol === 'https:' && (
                        host === 'youtube.com' || host.endsWith('.youtube.com')
                        || host === 'youtube-nocookie.com' || host.endsWith('.youtube-nocookie.com')
                        || host === 'onedrive.live.com' || host.endsWith('.onedrive.live.com')
                    );
                } catch (error) {
                    return false;
                }
            });

        if (!sources.length) return '—';
        return (
            <Space wrap>
                {sources.map((source, index) => (
                    <iframe
                        key={`${source}_${index}`}
                        title={`Video quay thưởng ${index + 1}`}
                        src={source}
                        width="320"
                        height="320"
                        frameBorder="0"
                        scrolling="no"
                        allowFullScreen
                    />
                ))}
            </Space>
        );
    };

    renderRow = (label, value) => (
        <Col xs={24}>
            <Descriptions size="small"><Descriptions.Item label={label}>{value || '—'}</Descriptions.Item></Descriptions>
            <Divider className="no-margin" />
        </Col>
    );

    render() {
        const { visible, currentItem, loadingDetail, onCancel, reloadData } = this.props;
        const images = Array.isArray(currentItem?.images) ? currentItem.images : [];

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Chi tiết khách hàng: ${currentItem?.full_name || ''}`}
                    onClose={onCancel}
                    maskClosable={false}
                    width={isMobile ? '100%' : '45%'}
                    extra={checkPermission('reward_spin', 'update') ? (
                        <Button type="primary" icon={<EditOutlined />} onClick={() => this.setState({ isOpenForm: true })}>Cập nhật</Button>
                    ) : null}
                >
                    {visible && (
                        <Spin tip="Đang tải..." spinning={loadingDetail}>
                            <Row gutter={16}>
                                {this.renderRow('Tên khách hàng', currentItem?.full_name)}
                                {this.renderRow('Mã khách hàng', currentItem?.code)}
                                {this.renderRow('Mã số thẻ cũ', currentItem?.card_number)}
                                {this.renderRow('Mã số thẻ mới', currentItem?.card_number_new)}
                                {this.renderRow('Giải thưởng', ConvertRewardType(currentItem?.type))}
                                {this.renderRow('Trạng thái', Number(currentItem?.status) === 1
                                    ? <Tag color="#015609">Đã nhận thưởng</Tag>
                                    : <Tag color="#ff7875">Chưa nhận thưởng</Tag>)}
                                {this.renderRow('Ngày quay', currentItem?.created_at ? isValidDate(currentItem.created_at) : null)}
                                {this.renderRow('Ngày hết hạn', currentItem?.expire_date ? isValidDate(currentItem.expire_date, false) : null)}
                                {this.renderRow('Ngày nhận thưởng', currentItem?.received_date ? isValidDate(currentItem.received_date) : null)}
                                {this.renderRow('Tỉnh/Thành phố', currentItem?.province_name)}
                                {this.renderRow('Phường/Xã', currentItem?.wards_name)}
                                {this.renderRow('Tổ', currentItem?.residential_group)}
                                {this.renderRow('Địa chỉ', currentItem?.address)}
                                {this.renderRow('Ghi chú', <span style={{ whiteSpace: 'pre-line' }}>{_newLine(currentItem?.note || '')}</span>)}
                                <Col xs={24}>
                                    <Text strong>Ảnh</Text>
                                    <div className="mt-2 mb-2">
                                        {images.length ? (
                                            <Image.PreviewGroup>
                                                <Space wrap>
                                                    {images.map((image, index) => (
                                                        <Image
                                                            key={image.manual_id || index}
                                                            height={60}
                                                            width={60}
                                                            src={image.src}
                                                            style={{ border: '1px solid #dedede', objectFit: 'cover' }}
                                                        />
                                                    ))}
                                                </Space>
                                            </Image.PreviewGroup>
                                        ) : '—'}
                                    </div>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24}>
                                    <Text strong>Video</Text>
                                    <div className="mt-2">{this.renderVideos(currentItem?.videos)}</div>
                                </Col>
                            </Row>
                        </Spin>
                    )}
                </Drawer>
                <RewardSpinForm
                    visible={this.state.isOpenForm}
                    currentItem={currentItem}
                    reloadData={reloadData}
                    onCancel={() => this.setState({ isOpenForm: false })}
                />
            </>
        );
    }
}

export default RewardSpinDetail;
